import { Fragment, ReactElement } from "react";
import { Stack, SwipeableDrawer } from "@mui/material";
import { DrawerContent } from "src/components/modal/basic-drawer/DrawerContent";
import { useScreenSize } from "src/hooks/useScreenSize";

export interface DrawerStyle {
    drawerPadding: string;
    modalWidth: string;
    mobileOffsetTop: string;
    borderRadius: string;
}

const desktopStyle: DrawerStyle = {
    drawerPadding: "1.5rem", // 24px
    modalWidth: "30rem", // 480px
    mobileOffsetTop: "0",
    borderRadius: "0",
};

const mobileStyle = (mobileOffsetTop: number) => {
    return {
        drawerPadding: "1rem", // 16px
        modalWidth: "100%",
        mobileOffsetTop: mobileOffsetTop + "px",
        borderRadius: "10px 10px 0 0",
    };
};

export interface BasicDrawerProps {
    title?: string | undefined | null;
    open: boolean;
    onClose?: () => void;
    TopComponent?: ReactElement;
    BottomComponent?: ReactElement;
    mobileOffsetTop?: number;
    showDivider?: boolean;
}

/**
 * @deprecated This component will be removed soon (hopefully). Please use SenecDrawer instead.
 */
export const BasicDrawer = ({
    title,
    open,
    onClose,
    TopComponent,
    BottomComponent,
    mobileOffsetTop = 50,
    showDivider = true,
}: BasicDrawerProps) => {
    const { isMobile } = useScreenSize();
    const style = isMobile ? mobileStyle(mobileOffsetTop) : desktopStyle;

    const handleClose = () => {
        if (onClose) onClose();
    };

    return (
        <Fragment>
            <SwipeableDrawer
                sx={{
                    ".MuiDrawer-paperAnchorRight": customDrawerStyle(style),
                }}
                anchor={"right"}
                open={open}
                onClose={handleClose}
                onOpen={() => {
                    /* no action required */
                }}
            >
                <Stack
                    data-testid="presentationdesktop-details"
                    sx={{
                        px: style.drawerPadding,
                        pt: style.drawerPadding,
                        overflow: "hidden",
                        height: "100%",
                    }}
                >
                    {title && (
                        <DrawerContent
                            isMobile={isMobile}
                            TopComponent={TopComponent}
                            BottomComponent={BottomComponent}
                            closeDrawerOnClick={handleClose}
                            style={style}
                            title={title}
                            showDivider={showDivider}
                        />
                    )}
                </Stack>
            </SwipeableDrawer>
        </Fragment>
    );
};

const customDrawerStyle = (style: DrawerStyle) => {
    return {
        marginTop: style.mobileOffsetTop,
        height: "100%",
        borderRadius: style.borderRadius,
        width: style.modalWidth,
        minWidth: "320px",
    };
};
